function initRspc(args) {
    return new AlphaClient(args);
}
const generateRandomId = ()=>Math.random().toString(36).slice(2);
// TODO: This will replace old client
class AlphaClient {
    async query(keyAndInput, opts) {
        try {
            const keyAndInput2 = this.mapQueryKey ? this.mapQueryKey(keyAndInput) : keyAndInput;
            const result = exec({
                id: generateRandomId(),
                type: "query",
                input: keyAndInput2[1],
                path: keyAndInput2[0],
                context: opts?.context || {}
            }, this.links);
            opts?.signal?.addEventListener("abort", result.abort);
            return await new Promise(result.exec);
        } catch (err) {
            if (this.onError) {
                this.onError(err);
            }
            throw err;
        }
    }
    async mutation(keyAndInput, opts) {
        try {
            const keyAndInput2 = this.mapQueryKey ? this.mapQueryKey(keyAndInput) : keyAndInput;
            const result = exec({
                id: generateRandomId(),
                type: "mutation",
                input: keyAndInput2[1],
                path: keyAndInput2[0],
                context: opts?.context || {}
            }, this.links);
            opts?.signal?.addEventListener("abort", result.abort);
            return await new Promise(result.exec);
        } catch (err) {
            if (this.onError) {
                this.onError(err);
            }
            throw err;
        }
    }
    // TODO: Handle resubscribing if the subscription crashes similar to what Tanstack Query does
    addSubscription(keyAndInput, opts) {
        try {
            const keyAndInput2 = this.mapQueryKey ? this.mapQueryKey(keyAndInput) : keyAndInput;
            const result = exec({
                id: generateRandomId(),
                type: "subscription",
                input: keyAndInput2[1],
                path: keyAndInput2[0],
                context: opts?.context || {}
            }, this.links);
            result.exec((data)=>opts?.onData(data), (err)=>opts?.onError?.(err));
            return result.abort;
        } catch (err) {
            if (this.onError) {
                this.onError(err);
            }
            return ()=>{};
        }
    }
    // TODO: Remove this once middleware system is in place
    dangerouslyHookIntoInternals(opts) {
        this.mapQueryKey = opts?.mapQueryKey;
        return this;
    }
    constructor(args){
        this._rspc_def = undefined;
        if (args.links.length === 0) {
            throw new Error("Must provide at least one link");
        }
        this.links = args.links;
        this.onError = args.onError;
    }
}
function exec(op, links) {
    if (!links[0]) throw new Error("No links provided");
    let prevLinkResult = {
        exec: ()=>{
            throw new Error("rspc: no terminating link was attached! Did you forget to add a 'httpLink' or 'wsLink' link?");
        },
        abort: ()=>{}
    };
    for(var linkIndex = 0; linkIndex < links.length; linkIndex++){
        const link = links[links.length - linkIndex - 1];
        const result = link({
            op,
            next: ()=>prevLinkResult
        });
        prevLinkResult = result;
    }
    return prevLinkResult;
}

class AlphaRSPCError extends Error {
    constructor(code, message){
        super();
        this.code = code;
        this.message = message;
    }
}

/**
 * HTTP Fetch link for rspc
 */ function httpLink(opts) {
    const fetchFn = opts.fetch || globalThis.fetch.bind(globalThis);
    const abortController = opts.AbortController || globalThis.AbortController.bind(globalThis);
    return ({ op  })=>{
        const abort = new abortController();
        return {
            exec: async (resolve, reject)=>{
                if (op.type === "subscription" || op.type === "subscriptionStop") {
                    reject(// TODO: Move to `AlphaRSPCError` type??
                    new Error(`Subscribing to '${op.path}' failed as the HTTP transport does not support subscriptions! Maybe try using the websocket transport?`));
                    return;
                }
                let method = "GET";
                let body = undefined;
                let headers = new Headers();
                const defaultHeaders = typeof opts.headers === "function" ? await opts.headers({
                    op
                }) : opts.headers;
                if (defaultHeaders) {
                    for (const [key, value] of Object.entries(defaultHeaders)){
                        if (Array.isArray(value)) {
                            for (const v of value){
                                headers.append(key, v);
                            }
                        } else {
                            headers.set(key, value || "");
                        }
                    }
                }
                const params = new URLSearchParams();
                if (op.type === "query") {
                    if (op.input !== undefined) {
                        params.append("input", JSON.stringify(op.input));
                    }
                } else if (op.type === "mutation") {
                    method = "POST";
                    body = JSON.stringify(op.input || {});
                    headers.set("Content-Type", "application/json");
                }
                const paramsStr = params.toString();
                const resp = await fetchFn(`${opts.url}/${op.path}${paramsStr.length > 0 ? `?${paramsStr}` : ""}`, {
                    method,
                    body,
                    headers,
                    signal: abort.signal
                });
                const respBody = await resp.json();
                const { type , data  } = respBody.result;
                if (type === "error") {
                    const { code , message  } = data;
                    reject(new AlphaRSPCError(code, message));
                    return;
                }
                resolve(data);
            },
            execBatch: async ()=>{},
            abort () {
                abort.abort();
            }
        };
    };
}
/**
 * Wrapper around httpLink that applies request batching. This is great for performance but may be problematic if your using HTTP caching.
 */ // TODO: Ability to use context to skip batching on certain operations
function httpBatchLink(opts) {
    const fetchFn = opts.fetch || globalThis.fetch.bind(globalThis);
    const abortController = opts.AbortController || globalThis.AbortController.bind(globalThis);
    const pushBatch = async (batch)=>{
        let headers = new Headers();
        const defaultHeaders = typeof opts.headers === "function" ? await opts.headers({
            ops: batch.map((b)=>b.op)
        }) : opts.headers;
        if (defaultHeaders) {
            for (const [key, value] of Object.entries(defaultHeaders)){
                if (Array.isArray(value)) {
                    for (const v of value){
                        headers.append(key, v);
                    }
                } else {
                    headers.set(key, value || "");
                }
            }
        }
        const resp = await fetchFn(`${opts.url}/_batch`, {
            method: "POST",
            headers,
            body: JSON.stringify(batch.map(({ op  })=>({
                    id: op.id,
                    method: op.type,
                    params: {
                        path: op.path,
                        input: op.input
                    }
                })))
        });
        // TODO: Get this type instead of using `any`
        const body = await resp.json();
        if (body.length !== batch.length) {
            console.error("rspc: batch response length mismatch!");
            return;
        }
        for (const [i, item] of body.entries()){
            const batchItem = batch[i];
            if (batchItem.abort.signal?.aborted) {
                continue;
            }
            if (item.result.type === "response") {
                batch[i]?.resolve(item.result.data);
            } else if (item.result.type === "error") {
                batch[i]?.reject(new AlphaRSPCError(item.result.data.code, item.result.data.message));
            } else {
                console.error("rspc: batch response type mismatch!");
            }
        }
    };
    const batch = [];
    let batchQueued = false;
    const queueBatch = ()=>{
        if (!batchQueued) {
            batchQueued = true;
            setTimeout(()=>{
                pushBatch([
                    ...batch
                ]);
                batch.splice(0, batch.length);
                batchQueued = false;
            });
        }
    };
    return ({ op  })=>{
        const abort = new abortController();
        return {
            exec: async (resolve, reject)=>{
                if (op.type === "subscription" || op.type === "subscriptionStop") {
                    reject(// TODO: Move to `AlphaRSPCError` type??
                    new Error(`Subscribing to '${op.path}' failed as the HTTP transport does not support subscriptions! Maybe try using the websocket transport?`));
                    return;
                }
                batch.push({
                    op,
                    resolve,
                    reject,
                    abort
                });
                queueBatch();
            },
            abort () {
                abort.abort();
            }
        };
    };
}

const timeouts = [
    1000,
    2000,
    5000,
    10000
]; // In milliseconds
function newWsManager(opts) {
    const WebSocket = opts.WebSocket || globalThis.WebSocket.bind(globalThis);
    const activeMap = new Map();
    let ws;
    const attachEventListeners = ()=>{
        ws.addEventListener("message", (event)=>{
            const { id , result  } = JSON.parse(event.data);
            if (activeMap.has(id)) {
                if (result.type === "event") {
                    activeMap.get(id)?.resolve(result.data);
                } else if (result.type === "response") {
                    activeMap.get(id)?.resolve(result.data);
                    activeMap.delete(id);
                } else if (result.type === "error") {
                    const { message , code  } = result.data;
                    activeMap.get(id)?.reject(new AlphaRSPCError(code, message));
                    activeMap.delete(id);
                } else {
                    console.error(`rspc: received event of unknown type '${result.type}'`);
                }
            } else {
                console.error(`rspc: received event for unknown id '${id}'`);
            }
        });
        ws.addEventListener("close", (event)=>{
            reconnectWs();
        });
    };
    const reconnectWs = (timeoutIndex = 0)=>{
        let timeout = // @ts-expect-error // TODO: Fix this
        (timeouts[timeoutIndex] ?? timeouts[timeouts.length - 1]) + (Math.floor(Math.random() * 5000 /* 5 Seconds */ ) + 1);
        setTimeout(()=>{
            let newWs = new WebSocket(opts.url);
            new Promise(function(resolve, reject) {
                newWs.addEventListener("open", ()=>resolve(null));
                newWs.addEventListener("close", reject);
            }).then(()=>{
                ws = newWs;
                attachEventListeners();
            }).catch((err)=>reconnectWs(timeoutIndex++));
        }, timeout);
    };
    const initWebsocket = ()=>{
        ws = new WebSocket(opts.url);
        attachEventListeners();
    };
    initWebsocket();
    const awaitWebsocketReady = async ()=>{
        if (ws.readyState == 0) {
            let resolve;
            const promise = new Promise((res)=>{
                resolve = ()=>res(undefined);
            });
            ws.addEventListener("open", ()=>resolve());
            await promise;
        }
    };
    return [
        activeMap,
        (data)=>awaitWebsocketReady().then(()=>ws.send(JSON.stringify(data)))
    ];
}
/**
 * Websocket link for rspc
 */ function wsLink(opts) {
    const [activeMap, send] = newWsManager(opts);
    return ({ op  })=>{
        // TODO: Get backend to send response if a subscription task crashes so we can unsubscribe from that subscription
        // TODO: If the current WebSocket is closed we should mark them all as finished because the tasks were killed on the server
        let finished = false;
        return {
            exec: async (resolve, reject)=>{
                activeMap.set(op.id, {
                    resolve,
                    reject
                });
                send({
                    id: op.id,
                    // @ts-expect-error // TODO: Fix this
                    method: op.type,
                    params: {
                        path: op.path,
                        input: op.input
                    }
                });
            },
            abort () {
                if (finished) return;
                finished = true;
                // TODO: We should probs still use dataloader internally to deal with create/delete events due to React strict mode.
                activeMap.delete(op.id);
                send({
                    id: op.id,
                    // @ts-expect-error // TODO: Fix this
                    method: "subscriptionStop",
                    // @ts-expect-error // TODO: Fix this
                    params: null
                });
            }
        };
    };
}
/**
 * Wrapper around wsLink that applies request batching.
 */ // TODO: Ability to use context to skip batching on certain operations
function wsBatchLink(opts) {
    const [activeMap, send] = newWsManager(opts);
    const batch = [];
    let batchQueued = false;
    const queueBatch = ()=>{
        if (!batchQueued) {
            batchQueued = true;
            setTimeout(()=>{
                send([
                    ...batch
                ]);
                batch.splice(0, batch.length);
                batchQueued = false;
            });
        }
    };
    return ({ op  })=>{
        // TODO: Get backend to send response if a subscription task crashes so we can unsubscribe from that subscription
        // TODO: If the current WebSocket is closed we should mark them all as finished because the tasks were killed on the server
        let finished = false;
        return {
            exec: async (resolve, reject)=>{
                activeMap.set(op.id, {
                    resolve,
                    reject
                });
                // @ts-expect-error // TODO: Fix this
                batch.push({
                    id: op.id,
                    method: op.type,
                    params: {
                        path: op.path,
                        input: op.input
                    }
                });
                queueBatch();
            },
            abort () {
                if (finished) return;
                finished = true;
                const subscribeEventIdx = batch.findIndex((b)=>b.id === op.id);
                if (subscribeEventIdx === -1) {
                    if (op.type === "subscription") {
                        // @ts-expect-error // TODO: Fix this
                        batch.push({
                            id: op.id,
                            method: "subscriptionStop",
                            params: null
                        });
                        queueBatch();
                    }
                } else {
                    batch.splice(subscribeEventIdx, 1);
                }
                activeMap.delete(op.id);
            }
        };
    };
}

// TODO: Pretty log output like tRPC's logger link
/**
 * Link for logging operations.
 *
 * This must go before the terminating link for it to work!
 *
 */ function loggerLink() {
    return ({ op , next  })=>{
        const result = next({
            op
        });
        console.log("REQUEST", op, next);
        return {
            exec: (resolve, reject)=>{
                result.exec((data)=>{
                    console.log("RESPONSE", op, data);
                    resolve(data);
                }, (err)=>{
                    console.error("RESPONSE ERROR", op, err);
                    reject(err);
                });
            },
            abort: ()=>{
                console.log("ABORT OP", op);
                result.abort();
            }
        };
    };
}

export { AlphaClient, AlphaRSPCError, httpBatchLink, httpLink, initRspc, loggerLink, wsBatchLink, wsLink };
